
import login_logo from './Images/Login/digidoc_logo.svg';
import stethoscope  from './Images/Login/stethoscope.svg';
import digi_bg from './Images/Login/digi_bg.png';
import tick_icon from './Images/Login/tick_icon.svg';
import eyeOpen from'./Images/Login/eyeopen.svg';
import eyeClose from'./Images/Login/eyeclosed.svg';
import home from './Images/SideMenu/home.svg';
import active_home from './Images/SideMenu/active_home.svg';
import appointment from './Images/SideMenu/appointment.svg';
import active_appointment from './Images/SideMenu/active_appointment.svg';
import clock from './Images/SideMenu/clock.svg';
import active_clock from './Images/SideMenu/active_clock.svg';
import patient from './Images/SideMenu/patient.svg';
import active_patient from './Images/SideMenu/active_patient.svg';
import analytics from './Images/SideMenu/analytics.svg';
import active_analytics from './Images/SideMenu/active_analytics.svg';
import contact from './Images/SideMenu/contact.svg';
import active_contact from './Images/SideMenu/active_contact.svg';
import profile from './Images/SideMenu/profile.svg';
import active_profile from './Images/SideMenu/active_profile.svg';
import digi_logo from './Images/SideMenu/Sidebar-logo.svg';
import logout_icon from './Images/SideMenu/logout_icon.svg';
import search_icon from './Images/SideMenu/search_icon.svg';
import notify_icon from './Images/SideMenu/notify_icon.svg';
import profile_icon from './Images/SideMenu/profile_icon.svg';
import doctors_image from './Images/Images/Doctors_image.png';
import edit_icon from './Images/Images/edit_icon.svg';
import filter_icon from './Images/Images/filter_icon.svg';
import consult_icon from './Images/Images/consult_icon.svg';
import medicine_icon from './Images/Images/medicine_icon.svg';
import labTest_icon from './Images/Images/labTest_icon.svg';
import homeTest_icon from './Images/Images/homeTest_icon.svg';
import plus_icon from './Images/Images/plus_icon.svg';
import patient_added from './Images/Images/patient_added.svg';
import close_icon from './Images/Images/close_icon.svg';
import blood_icon from './Images/Images/blood_icon.svg';
import bp_icon from './Images/Images/bp_icon.svg';
import lap_icon from './Images/Images/lap_icon.svg';
import lap_icon_bg from './Images/Images/lap_icon_bg.svg';
import pic_icon from './Images/Images/pic_icon.svg';
import report from './Images/Images/report.png';
import back_icon from './Images/Images/back_icon.svg';
import medi_icon_bg from './Images/Images/medi_icon_bg.svg';
import morning from './Images/Images/morning.svg';
import cloud from './Images/Images/cloud.svg';
import clock_icon from './Images/Images/clock_icon.svg';
import cancelReq from './Images/Images/cancelReq.svg';
import success_tick from './Images/Images/success_tick.svg';
import eyeview from './Images/Images/eye.png'
import doctor from './Images/Images/doctor.png'
import backarrow from './Images/Images/back_icon.svg'
import ActiveRight from './Images/Images/Active-Right.svg'
import InactiveLeft from './Images/Images/InActive-Left.svg'
import Moon from './Images/Images/Moon.svg'
import Sun from './Images/Images/afternoon.svg'
import Sunrise from './Images/Images/Sunrise.svg'
import ColoredSunrise from './Images/Images/ColoredSunrise.svg'
import ColoredSun from './Images/Images/ColoredSun.svg'
import ColoredCloud from './Images/Images/ColoredCloud.svg'
import ColoredMoon from './Images/Images/ColoredMoon.svg'


const Assets ={
    login_logo,
    stethoscope,
    digi_bg,
    tick_icon,
    eyeOpen,
    eyeClose,
    home,
    active_home,
    appointment,
    active_appointment,
    clock,
    active_clock,
    patient,
    active_patient,
    analytics,
    active_analytics,
    profile,
    active_profile,
    contact,
    active_contact,
    digi_logo,
    logout_icon,
    search_icon,
    notify_icon,
    profile_icon,
    doctors_image,
    edit_icon,
    filter_icon,
    consult_icon,
    medicine_icon,
    plus_icon,
    labTest_icon,
    homeTest_icon,
    patient_added,
    close_icon,
    blood_icon,
    bp_icon,
    lap_icon,
    lap_icon_bg,
    pic_icon,
    report,
    back_icon,
    medi_icon_bg,
    morning,
    cloud,
    clock_icon,
    cancelReq,
    success_tick,
    eyeview,
    doctor,
    backarrow,
    ActiveRight,
    InactiveLeft,
    Moon,
    Sun,
    Sunrise,
    ColoredSunrise,
    ColoredSun,
    ColoredCloud,
    ColoredMoon,
}

export default Assets